module.exports = {
	"ha": "vcha",
	"id": 5.6,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by PWID Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 99.03846153846155,
						"dataLabels": {
							"enabled": true,
							"format": "927"
						}
					},
					{
						"y": 98.07692307692307,
						"dataLabels": {
							"enabled": true,
							"format": "918"
						}
					},
					{
						"y": 94.65811965811966,
						"dataLabels": {
							"enabled": true,
							"format": "886"
						}
					},
					{
						"y": 86.43162393162393,
						"dataLabels": {
							"enabled": true,
							"format": "809"
						}
					},
					{
						"y": 64.1025641025641,
						"dataLabels": {
							"enabled": true,
							"format": "600"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.49564528899447,
						"dataLabels": {
							"enabled": true,
							"format": "2488"
						}
					},
					{
						"y": 91.68646080760095,
						"dataLabels": {
							"enabled": true,
							"format": "2316"
						}
					},
					{
						"y": 89.27157561361837,
						"dataLabels": {
							"enabled": true,
							"format": "2255"
						}
					},
					{
						"y": 84.24386381631037,
						"dataLabels": {
							"enabled": true,
							"format": "2128"
						}
					},
					{
						"y": 73.95091053048297,
						"dataLabels": {
							"enabled": true,
							"format": "1868"
						}
					},
					{
						"y": null
					},
					{
						"y": 90.633608815427,
						"dataLabels": {
							"enabled": true,
							"format": "987"
						}
					},
					{
						"y": 67.4931129476584,
						"dataLabels": {
							"enabled": true,
							"format": "735"
						}
					},
					{
						"y": 65.47291092745638,
						"dataLabels": {
							"enabled": true,
							"format": "713"
						}
					},
					{
						"y": 62.0752984389348,
						"dataLabels": {
							"enabled": true,
							"format": "676"
						}
					},
					{
						"y": 52.43342516069789,
						"dataLabels": {
							"enabled": true,
							"format": "571"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -0.9615384615384581,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.9708737864077666,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4858387799564294,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.690744920993232,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.834363411619286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.50435471100554,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.913183279742762,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.633851468048354,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.631929046563188,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.218045112781951,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.366391184572997,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.531914893617024,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.9931972789115635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.189340813464238,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.532544378698221,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=936"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=2526"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=1089"
			}
		],
		"dataTable": {
			"IDU": [
				936,
				927,
				918,
				886,
				809,
				600
			],
			"Non-IDU": [
				2526,
				2488,
				2316,
				2255,
				2128,
				1868
			],
			"Unknown": [
				1089,
				987,
				735,
				713,
				676,
				571
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_6.json
// module id = 307
// module chunks = 0